/**
 * @file Alert.js
 * @version 1.0.1
 * @author Cam Seymour
 * @project Excel Agri System
 * @created 2025-09-21
 * @modified 2025-10-01
 */

import './Alert.css';

export function showAlert(message, type = 'info') {
  const alertContainer = document.getElementById('alert-container') || createAlertContainer();

  const alert = document.createElement('div');
  alert.className = `custom-alert ${type}`;

  // Create icon span
  const iconSpan = document.createElement('span');
  iconSpan.className = 'material-symbols-rounded';
  iconSpan.textContent = getIcon(type);

  // Create message span - textContent prevents XSS
  const messageSpan = document.createElement('span');
  messageSpan.textContent = message; // Safe - auto-escapes HTML

  // Create close button
  const closeButton = document.createElement('button');
  closeButton.className = 'alert-close';
  const closeIcon = document.createElement('span');
  closeIcon.className = 'material-symbols-rounded';
  closeIcon.textContent = 'close';
  closeButton.appendChild(closeIcon);

  // Assemble alert
  alert.appendChild(iconSpan);
  alert.appendChild(messageSpan);
  alert.appendChild(closeButton);

  alertContainer.appendChild(alert);

  // Auto remove after 10 seconds
  setTimeout(() => {
    alert.classList.add('fade-out');
    setTimeout(() => alert.remove(), 300);
  }, 10000);

  // Manual close
  closeButton.addEventListener('click', () => {
    alert.classList.add('fade-out');
    setTimeout(() => alert.remove(), 300);
  });
}

function createAlertContainer() {
  const container = document.createElement('div');
  container.id = 'alert-container';
  document.body.appendChild(container);
  return container;
}

function getIcon(type) {
  switch(type) {
    case 'success': return 'check_circle';
    case 'error': return 'cancel';
    case 'warning': return 'warning';
    default: return 'info';
  }
}